import Highcharts from "highcharts/es-modules/masters/highcharts.src.js";
import { Chart } from "@highcharts/react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { formatCurrency, formatPercent } from "../../../utils/formatNumber";

interface ChartProps {
  data: { title?: string; current: number; previous: number; color: string }[];
  precision?: number;
  isCurrency?: boolean;
  isPercentage?: boolean;
  currentLabel?: string;
}

export function CurrentVsPreviousGroupedColumnChart({
  precision = 2,
  data,
  isCurrency,
  isPercentage,
  currentLabel,
}: ChartProps) {
  const { t } = useTranslation(["pricingv2"]);
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const filteredData = data.filter(({ current, previous }) => current !== 0 || previous !== 0);

  const options: Highcharts.Options = {
    title: {
      text: "",
    },
    chart: {
      type: "column",
      style: {
        fontFamily: "Poppins",
        fontSize: "15px",
        cursor: "zoom-in",
      },
      height: "280px",
    },
    tooltip: {
      valueDecimals: precision,
    },
    xAxis: {
      categories: [t(($) => $.pricingv2["Previous"]), currentLabel ?? t(($) => $.pricingv2["Current"])],
    },
    legend: { enabled: false, verticalAlign: "top", margin: 0 },
    yAxis: [{ title: { text: "" } }],
    plotOptions: {
      column: {
        stacking: "normal",
        pointPadding: 0.05,
        groupPadding: 0.05,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "13px",
          },
          formatter: function () {
            if (isPercentage) {
              return formatPercent(this.y ?? 0, { decimalPlaces: precision });
            }
            return isCurrency ?
                formatCurrency(this.y ?? 0, {
                  marketPlace: marketPlace,
                  compact: true,
                })
              : Highcharts.numberFormat(this.y ?? 0, precision, ".", ",");
          },
        },
      },
    },
    series: filteredData.map(({ current, previous, title, color }) => {
      const maskedCurrent = current === 0 ? null : current;
      const maskedPrevious = previous === 0 ? null : previous;
      return {
        name: title,
        type: "column",
        data: [maskedPrevious, maskedCurrent],
        color: color,
      };
    }),
  };
  return <Chart options={options} />;
}
